Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.alternativeButtonStyle = exports.standardButtonStyle = void 0;
var standardButtonStyle = {
  borderRadius: 2,
  borderX: 1,
  borderY: 1,
  borderColor: 'highlight.secondary',
  bg: 'background.main'
};
exports.standardButtonStyle = standardButtonStyle;
var alternativeButtonStyle = {
  borderRadius: 2,
  bg: 'highlight.secondary'
};
exports.alternativeButtonStyle = alternativeButtonStyle;